import { render, staticRenderFns } from "./Signage.vue?vue&type=template&id=2b43a074&scoped=true"
import script from "./Signage.vue?vue&type=script&lang=ts"
export * from "./Signage.vue?vue&type=script&lang=ts"
import style0 from "./Signage.vue?vue&type=style&index=0&id=2b43a074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43a074",
  null
  
)

export default component.exports